import alertsSlice from './slice';

export default alertsSlice.reducer;
